import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { OrdersModalComponent } from './orders-modal.component';
import { ConfigService } from '@core/config/config.service';


@Component({
  selector: 'app-order-field',
  templateUrl: './order-field.component.html',
  styles: [],

  // This part is reponsible for the integration of the input inside the angular forms
  // It allows angular formControl element to communicate with our custom input
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: OrderFieldComponent,
    multi: true
  }]
})
export class OrderFieldComponent implements OnInit, ControlValueAccessor {
  @Input() public disabled: boolean;
  @Input() public filters: any;
  @Input() public disabledColumns: any;
  @Input() public disabledButtons: any;
  @Input() public financeMode = false;

  public detail: any;
  public onChangeCb: any;
  public detailBaseUrl: string;
  public salesforceBaseUrl: string;
  public localDisabledColumns = {
    detail: true
  };

  constructor(private ngbModal: NgbModal, private config: ConfigService) {
    this.salesforceBaseUrl = this.config.salesforceBaseUrl;
  }

  public ngOnInit(): void {
    this.localDisabledColumns = {...this.localDisabledColumns, ...this.disabledColumns};
    if (this.financeMode) {
      this.detailBaseUrl = '/orders/detail/';
    } else {
      this.detailBaseUrl = '/orders-mrp/detail/';
    }

  }

  public choose(): void {
    if (this.disabled) {
      return;
    }

    const modal = this.ngbModal.open(OrdersModalComponent, {size: 'lg'});
    modal.componentInstance.disabledColumns = this.localDisabledColumns;
    modal.componentInstance.disabledButtons = this.disabledButtons;
    modal.componentInstance.filters = this.filters;
    modal.componentInstance.financeMode = this.financeMode;

    modal.result.then((res) => {
      this.detail = res;
      this.onChangeCb(this.detail);
    }, () => {});
  }

  public reset(): void {
    this.detail = null;
    this.onChangeCb(this.detail);
  }


  // These 3 functions are part of the NG_VALUE_ACCESSOR
  // they must be implemented for Angular to access our input
  public writeValue(value): void {
    // This function is called by Angular when the formControl element has its value updated
    this.detail = value;
  }

  public registerOnChange(fn) {
    // This function is used by Angular to listen to the update of our custom control
    this.onChangeCb = fn;
  }

  public registerOnTouched() {
    // This function is used by Angular to know if our element has been touched by the user
  }
}
